import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/worried-girl.svg'


const _hoisted_1 = {
  id: "modal-different-computer-error",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = { class: "fs-6 text-start mt-4" }

import { Modal, Tooltip } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'

  import { ref, onMounted } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalDifferentComputerError',
  setup(__props, { expose: __expose }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  onMounted(() => {
    modal.value = new Modal('#modal-different-computer-error', {
      backdrop: 'static',
      keyboard: false,
    })
    new Tooltip('#extra-info', {
      title:
        'Para preservar a integridade e segurança do Certificado Digital A1, a chave privada é gerada e mantida na máquina original de instalação, não podendo ser reinstalada em outro dispositivo.',
      placement: 'top',
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "modal-header pb-3" }, [
          _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Atenção!", -1)),
          _createElementVNode("button", {
            class: "btn-close",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: hide
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            alt: "sucesso",
            src: _imports_0
          }, null, -1)),
          _createElementVNode("p", _hoisted_5, [
            _cache[1] || (_cache[1] = _createTextVNode(" Ops! Parece que ")),
            _cache[2] || (_cache[2] = _createElementVNode("strong", null, "você está usando um computador diferente", -1)),
            _cache[3] || (_cache[3] = _createTextVNode(" do utilizado no início do processo de emissão. ")),
            _createVNode(IconComponent, {
              id: "extra-info",
              name: "circle-question"
            })
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, [
            _createElementVNode("strong", null, "Acesse a página no computador correto"),
            _createTextVNode(" para continuar a instalação do seu Certificado Digital. ")
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})